export default "<!-- =============== NORMAL OUTLINED ICONS (18×18 px) =============== -->\n<div [outerHTML]=\"this.svg\"></div>\n"